module.exports = __webpack_public_path__ + "static/media/ADT.f6c9d00b.png";